// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingHomepage_container__3ylHX"};